import React from 'react'
import PropTypes from 'prop-types'

const DashboardBox = props => {
  const detailLink = props.detailLink ? (
    <a href={props.detailLink}>{props.detailText}</a>
  ) : (
    <div />
  )

  return (
    <div className="h-100 card-myed">
      <span className="pull-right">{props.helpIcon}</span>
      <h3>{props.title}</h3>
      <div>{props.children}</div>
      <div className="text-right" id="detail_link">
        {detailLink}
      </div>
    </div>
  )
}

DashboardBox.propTypes = {
  title: PropTypes.string.isRequired,
  helpIcon: PropTypes.element,
  detailLink: PropTypes.string,
  detailText: PropTypes.string,
}

DashboardBox.defaultProps = {
  detailText: 'View Detail',
}

export default DashboardBox
